import CupsListTableRow from './CupsListTableRow';

export default CupsListTableRow;
